import { AptunoButton, useResponsive, VARIANTS } from '@aptuno/aptuno-ui';
import { Response } from '@shared/models';
import { getLocalStorageItem, UTMBuilder } from '@shared/utils';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useEstateApplicationActions } from '../../store';

const constants = {
  ESTATE_APPLICATION_RESULTS_PAGE_URL: '/estate-application/results-application',
  UTM_PARAMS: {
    UTM_SOURCE: 'complete_application_navbar_button',
    UTM_MEDIUM: 'aptuno_web_ssr',
    UTM_CAMPAIGN: 'complete_application_from_aptuno',
  },
};

export const CompleteEstateApplicationButton = () => {
  const router = useRouter();
  const { isMobile } = useResponsive();

  const [user, setUser] = useState<any>();
  const data = getLocalStorageItem('user-data');

  const {
    result: userHasAnActiveAndNotCalculatedEstateApplication,
    get: validateIfUserHasAnActiveAndNotCalculatedEstateApplication,
  } =
    useEstateApplicationActions().estateApplciationQueryActions.useValidateIfUserHasAnActiveAndNotCalculatedEstateApplication();

  useEffect(() => {
    setUser(data && JSON.parse(data));
  }, [data]);

  useEffect(() => {
    if (!!user) {
      validateIfUserHasAnActiveAndNotCalculatedEstateApplication();
    }
  }, [user]);

  const isInEstateApplicationResultsPage = router.pathname === constants.ESTATE_APPLICATION_RESULTS_PAGE_URL;

  const handelCompleteEstateApplicationClick = () => {
    router.push(constants.ESTATE_APPLICATION_RESULTS_PAGE_URL.concat(UTMBuilder.build(constants.UTM_PARAMS)));
  };

  const thereAreEstateApplications =
    Response.isSucceed(userHasAnActiveAndNotCalculatedEstateApplication) &&
    userHasAnActiveAndNotCalculatedEstateApplication.result;

  return thereAreEstateApplications && !isInEstateApplicationResultsPage && !isMobile ? (
    <AptunoButton appearance={VARIANTS.INFORMATIVE} onClick={handelCompleteEstateApplicationClick}>
      Continuar arrendando
    </AptunoButton>
  ) : null;
};
